export const DASHBOARD_OPEN = 'DASHBOARD_OPEN'
export const SUBSCRIBER_OPEN = 'SUBSCRIBER_OPEN'
export const LOCATIONS_OPEN = 'LOCATIONS_OPEN'
export const PRODUCTS_OPEN = 'PRODUCTS_OPEN'
export const QRCODE_OPEN = 'QRCODE_OPEN'
export const EMPLOYEES_OPEN = 'EMPLOYEES_OPEN'
export const MANAGE_FAQS_OPEN = 'MANAGE_FAQS_OPEN'
export const SETTINGS_OPEN = 'SETTINGS_OPEN'